import { GetCounterpartiesQuery } from "@common/schemas/counterparty.schema";
import { CORPORATE_FEDERAL_TAX_CLASSIFICATIONS } from "@common/types/counterparty";
import {
    COUNTERPARTY_REVIEW_FIELD_LABELS,
    CounterpartyReviewField,
} from "@common/types/counterpartyFieldReview";

export type Form1099ReviewFilterMode =
    | "all"
    | "suggested"
    | "reviewed"
    | "unreviewed";

type Form1099ReviewQueryFilters = Pick<
    GetCounterpartiesQuery,
    | "excludedFederalTaxClassifications"
    | "excludeForeignAddresses"
    | "excludeRecognizedCorporations"
    | "counterpartyReviewedFields"
    | "counterpartyReviewedFieldsMode"
    | "counterpartyUnreviewedFields"
    | "counterpartyUnreviewedFieldsMode"
    | "counterpartyReviewerIds"
    | "counterpartyReviewerMode"
>;

/**
 * Runtime review filters for the FORM_1099 task sticky All / To review /
 * Reviewed select. Not persisted on the template — same pattern as
 * TRANSACTION_REVIEW.
 */
export function buildForm1099ReviewQueryFilters({
    mode,
    userId,
}: {
    mode: Form1099ReviewFilterMode;
    userId: number;
}): Form1099ReviewQueryFilters {
    if (mode === "all") {
        return {};
    }

    if (mode === "suggested") {
        return {
            counterpartyUnreviewedFields: [
                CounterpartyReviewField.ELIGIBLE_1099,
            ],
            counterpartyUnreviewedFieldsMode: "any",
            excludedFederalTaxClassifications:
                CORPORATE_FEDERAL_TAX_CLASSIFICATIONS,
            excludeForeignAddresses: true,
            excludeRecognizedCorporations: true,
        };
    }

    if (mode === "unreviewed") {
        return {
            counterpartyUnreviewedFields: [
                CounterpartyReviewField.ELIGIBLE_1099,
            ],
            counterpartyUnreviewedFieldsMode: "any",
        };
    }

    return {
        counterpartyReviewedFields: [CounterpartyReviewField.ELIGIBLE_1099],
        counterpartyReviewedFieldsMode: "every",
        counterpartyReviewerIds: [userId],
        counterpartyReviewerMode: "all",
    };
}

export function getForm1099ImplicitFilterLabels(
    mode: Form1099ReviewFilterMode,
): string[] {
    if (mode !== "suggested") {
        return [];
    }

    return [
        `Unreviewed: ${COUNTERPARTY_REVIEW_FIELD_LABELS[CounterpartyReviewField.ELIGIBLE_1099]}`,
        "Excludes corporations",
        "Excludes foreign addresses",
    ];
}
